import {
    registerAbsence,
    searchAbsence,
    findAllAbsences,
    deleteAbsences
} from "@/services/endpoints/absenceUsers";

export default {

    async registerAbsence({commit}, payload) {
        try {
            let res = await registerAbsence(payload);
            if (res.data) {
                return res.data;
            }
        } catch (err) {
            throw new Error(err);
        }
    },

    async searchAbsence({commit}, payload) {
        try {
            let res = await searchAbsence(payload);
            if (res.data.data) {
                commit('SET_TOTAL', res.data.total)
                return res.data.data;
            }
        } catch (err) {
            throw new Error(err);
        }
    },
    async findAllAbsences({commit},payload) {
        try {
            let res = await findAllAbsences(payload.unitId,payload.date);
            if (res.data) {
                return res.data;
            }
        } catch (err) {
            throw new Error(err);
        }
    },
    async deleteAbsences({commit},payload) {
        try {
            let res = await deleteAbsences(payload.absenceOfUserId);
            if (res.data) {
                return res.data;
            }
        } catch (err) {
            throw new Error(err);
        }
    },
};
